import moment from "moment";

export function formatDate(date) {
  if (moment(date, "DD-MM-YYYY", true).isValid()) {
    return date;
  }
  return moment(date).format("DD-MM-YYYY");
}

export function formatDate2(date) {
  if (moment(date, "DD/MM/YYYY", true).isValid()) {
    return date;
  }
  return moment(date).format("DD/MM/YYYY");
}

export function dateCheck(date) {
  const today = new Date();
  const inputDate = new Date(date);

  // Set time to midnight to compare only the date part
  today.setHours(0, 0, 0, 0);
  inputDate.setHours(0, 0, 0, 0);

  return today >= inputDate;
}
